import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store.js'

Vue.use(Router)


let router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		{
			path: '*',
			redirect: { name: 'home' }
		},
		{
			path: '/',
			name: 'root',
			component: () => import('@/views/Home.vue'),
			beforeEnter: (to, from, next) => {
				// init app -> redirect to card info
				if(to.name === 'root' && from.name === null) {
					next({ name: 'home' })
				} else {
					next()
				}
			},
			children: [
				{
					path: '/cardinfo',
					name: 'home',
					component: () => import('@/views/SingleCardInfo.vue'),
					beforeEnter (to, from, next) {
						store.dispatch('fetchNews', { lang: store.state.lang, season: store.state.season })
						store.dispatch('fetchCardInfos', { lang: store.state.language, season: store.state.season })
						next()
					}
				},
				{
					path: '/companies',
					name: 'companies',
					component: () => import('@/views/CompaniesList.vue'),
					beforeEnter(to, from, next) {
						store.dispatch('fetchCategories', { lang: store.state.language, season: store.state.season })
						store.dispatch('fetchCriterias', { lang: store.state.language, season: store.state.season })
						store.dispatch('fetchBonusCategories', { lang: store.state.language, season: store.state.season })
						next()
					}
				},
				{
					path: '/buy-card',
					name: 'buy-card',
					component: () => import('@/views/ShopList.vue')
				}
			]
		},
		{
			path: '/my-card',
			name: 'my-card',
			component: () => import('@/views/MyCard.vue'),
			beforeEnter(to, from, next) {
				if (store.state.cards.length >= 1) {
					next()
				} else {
					next({ name: 'my-card-register' })
				}
			}
		},
		{
			path: '/my-card/register',
			name: 'my-card-register',
			component: () => import('@/views/MyCardRegister.vue')
		},
		{
			path: '/map',
			name: 'map',
			component: () => import('@/views/Map.vue'),
			beforeEnter(to, from, next) {
				if (to.name === 'map' && from.name === 'bookmarks') {
					to.params.filtered = 'bookmarks'
				}
				next()
			}
		},
		{
			path: '/news',
			name: 'news',
			component: () => import('@/views/News.vue')
		},
		{
			path: '/services',
			name: 'services',
			component: () => import('@/views/Services.vue'),
			children: [
				{
					path: 'destinations/:uuid',
					name: 'single-destination',
					component: () => import('@/views/SingleCompany.vue'),
					beforeEnter(to, from, next) {
						let id = to.params.uuid
						store.dispatch('fetchCompany', { id: id})
						next()
					}
				},
				{
					path: 'bonus-club/:uuid',
					name: 'single-bonus-club',
					component: () => import('@/views/SingleBonusClub.vue')
				},
				{
					path: 'salespoints/:uuid',
					name: 'single-salespoint',
					component: () => import('@/views/SingleSalespoint.vue'),
					beforeEnter(to, from, next) {
						let id = to.params.uuid
						store.dispatch('fetchSalepoint', { id: id})
						next()
					}
				},
				{
					path: '/news/:uuid',
					name: 'single-news',
					component: () => import('@/views/SingleNews.vue')
				},{
					path: 'cardinfos/:uuid',
					name: 'single-card-info',
					component: () => import('@/views/SingleCardInfo.vue')
				}
			]
		},
		{
			path: '/bookmarks',
			name: 'bookmarks',
			component: () => import('@/views/Bookmarks.vue'),
		}
	]
})


export default router